<template>
    <div ref="modal" class="modal fade" :class="{ show: active, 'd-block': active }" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Customer: {{ data.customer_name }}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" v-on:click="$emit('closeModal')"
                        aria-label="btn-close"></button>
                </div>

                <form ref="formElement" class="forms-sample" method="POST" @submit.prevent="submitData">
                    <div class="modal-body">

                        <div class="row ">
                            <div class="col-md-3">
                                <label class="form-label mt-2">Billable Methode</label>
                            </div>

                            <div class="col-md-4 mt-2">
                                {{ data.billable_method }}
                            </div>


                        </div>


                        <div class="row ">
                            <div class="col-md-3">
                                <label class="form-label mt-2">Periode</label>
                            </div>

                            <div class="col-md-4 mt-2">
                                {{ data.periode }}
                            </div>


                        </div>


                        <div class="row ">
                            <div class="col-md-3">
                                <label class="form-label mt-2">SKU</label>
                            </div>

                            <div class="col-md-4 mt-2">
                                {{ data.sku }}
                            </div>


                        </div>


                        <div class="row ">
                            <div class="col-md-3">
                                <label class="form-label mt-2">Max Trip</label>
                            </div>

                            <div class="col-md-4 mt-2">
                                {{ data.max_trip }}
                            </div>


                        </div>


                        <div class="row ">
                            <div class="col-md-3">
                                <label class="form-label mt-2">Rate</label>
                            </div>

                            <div class="col-md-1 mt-2">Rp</div>
                            <div class="col-md-4 mt-2">
                                {{ formatNumber(data.contract_rate) }}
                            </div>


                        </div>



                        <!--end::loading-data-->
                        <!-- <h5>{{ $t("areYouSure") }}</h5> -->



                        <div class="row ">
                            <div class="col-md-3">
                                <label class="form-label mt-2">Jumlah Truck</label>
                            </div>

                            <div class="col-md-4">

                                {{ data.JumlahTruck }}

                            </div>




                        </div>


                        <div class="row ">
                            <div class="col-md-3">
                                <label class="form-label mt-2">SAP Code</label>
                            </div>

                            <div class="col-md-4">

                                {{ sap_code }} 

                            </div>




                        </div>


                        <div class="row " v-if="permision_role.method_custom2 && data.status!='Send To Billing'">
                            <div class="col-md-3">
                                <label class="form-label mt-2">Calculate</label>
                            </div>

                            <div class="col-md-4">
                                <multiselect v-model="calculate" :show-labels="false" :options="fetchCalculate"
                                    placeholder="Search " label="name" track-by="name"></multiselect>
                            </div>

                            <div class="col-md-4" >
                                <span class="btn btn-success" v-if="!isLoadingCalculate"
                                    @click="loadCalculate">Calculate</span>
                                <div v-if="isLoadingCalculate" class="d-flex align-items-center">
                                    <div class="spinner-border ms-auto" role="status" aria-hidden="true"></div>
                                    <strong>Loading...</strong>
                                </div>
                            </div>


                        </div>


                        <div class="row">
                            <div class="table-responsive">
                                <table class="table table-responsive">
                                    <thead>
                                        <tr>
                                            <th>No</th>
                                            <!-- <th>Action</th> -->
                                            <th>Periode</th>
                                            <th>Truck No</th>
                                            <th>Billable Method</th>
                                            <th>SKU</th>
                                            <th>Harga Jual</th>
                                            <th>Trip</th>
                                            <th>Trip Tagih</th>
                                            <th>Nopol</th>
                                            <th>Notes</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-if="fetchData.length == 0">
                                            <tr>
                                                <th colspan="9">No Data</th>
                                            </tr>
                                        </template>
                                        <template v-else>
                                            <tr v-for="(list, key) in fetchData" :key="key">

                                                <td>{{ key + 1 }}</td>
                                                <!-- <td></td> -->
                                                <td>
                                                    <input type="text" class="form-control" name="listperiode"
                                                        v-model="list.periode" />
                                                </td>
                                                <td>
                                                    <input type="text" class="form-control" name="listperiode"
                                                        v-model="list.truck_no" />
                                                </td>
                                                <td>

                                                    <input type="text" class="form-control" name="listperiode"
                                                        v-model="list.billable_method" />
                                                </td>
                                                <td>
                                                    <input type="text" class="form-control" name="listperiode"
                                                        v-model="list.sku" />
                                                </td>
                                                <td>

                                                    <!-- <input type="text" class="form-control" name="listperiode"
                                                        v-model="list.harga_jual" /> -->
                                                    <CurrencyInput v-model.number="list.harga_jual"
                                                        :options="{ currency: 'IDR' }" class="form-control" />
                                                </td>
                                                <td>

                                                    <input type="text" class="form-control" name="listperiode"
                                                        v-model="list.trip" />
                                                </td>
                                                <td>

                                                    <input type="text"  class="form-control" name="listperiode"
                                                        v-model="list.trip_tagih"   @input="updateHargaJual(list)" />
                                                </td>
                                                <td>
                                                    <input type="text" class="form-control" name="listperiode"
                                                        v-model="list.vehicle_no" />
                                                </td>

                                                <td>

                                                    <!-- <input type="text" class="form-control" name="listperiode"
                                                        v-model="list.notes" /> -->
                                                        <textarea class="form-control" cols="150" v-model="list.notes"></textarea>
                                                </td>

                                            </tr>
                                        </template>

                                    </tbody>
                                </table>
                            </div>
                        </div>







                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" v-on:click="$emit('closeModal')">
                            No
                        </button>

                        <div v-if="isLoading" class="d-flex align-items-center">
                            <div class="spinner-border ms-auto" role="status" aria-hidden="true"></div>
                            <strong>Loading...</strong>
                        </div>

                        <button v-if="user_type=='CT' && !isLoading && fetchData.length > 0 && data.status!='Send To Billing'" class="btn btn-primary" type="submit">Yes 
                        </button>


                        <button v-if="!isLoading && fetchData.length > 0 && user_type=='CHAIN'" class="btn btn-primary" type="submit">Yes 
                        </button>

                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
// import moment from "moment";
import multiselect from "vue-multiselect";
import CurrencyInput from '@/components/_partials/inputCurrency.vue';

//   import Datepicker from "vuejs-datepicker";

export default {

    components: {
        "multiselect": multiselect,
        CurrencyInput,
        // Datepicker
    },
    name: "ModalFormCancelFPPK",
    emits: ["closeModal"],

    props: {
        showModal: Boolean,
        data: null,
        sap_code: null,
    },
    watch: {
        showModal: {

            handler(newVal) {
                if (this.sap_code) {
                    this.sapcode = this.sap_code;
                }
                console.log(this.data);
                this.fetchData = [];
                if (this.data != '') {
                    this.fetchIt();
                    if (this.data.kalkulasi.length > 0) {
                    

                        this.fetchData = this.data.kalkulasi.map(item => ({
                        ...item,
                        harga_jual_awal: item.harga_jual  // simpan nilai awal
                        }))

                    }

                }
                //console.log(this.data);
                // if (this.data != '') {


                //   // const startDate = this.data.delivery_date;
                //   // const endDate = new Date();

                //   // const startDate2 = this.data.return_date;
                //   // const endDate2 = new Date();

                //   this.forms = 
                //   {
                //       assign_driver  : '',
                //       assign_name_driver  : '',
                //       assign_date  :'',
                //       remarks_close  : ''
                //   }




                // } else {

                //   //const startDate = new Date();
                //   //const endDate = new Date();
                //   this.forms = {
                //       assign_driver  : '',
                //       assign_name_driver  : '',
                //       assign_date  :'',
                //       remarks_close  : ''
                //   };


                // }

                // this.forms = {
                //     assign_driver: '',
                //     assign_name_driver: '',
                //     assign_date: '',
                //     remarks_close: ''
                // };

                this.active = newVal;
                const body = document.querySelector("body");
                this.showModal
                    ? body.classList.add("modal-open")
                    : body.classList.remove("modal-open");

                //this.loadDriver();

            },
            immediate: true,
            deep: true,
        },
    },
    data() {
        return {
            user_type :'',
            fetchData: [],
            permision_role: [],
            calculate: "",
            fetchCalculate: [
                {
                    name: 'AS IS'
                },
                {
                    name: 'Prorate'
                },
                {
                    name: 'DEDICATED'
                }
            ],
            fetchDriver: [],
            driver: "",
            isLoading: false,
            isLoadingCalculate: false,
            active: this.showModal,
            forms: [],
            sapcode: "",
            locale: [],
            return_date: [],
            delivery_date: [],
            equipment_name: [],
            fetchEquipmentName: [],
            lumpsumKalkulasi: [],
        };
    },
    methods: {

        resetForm() {
            this.forms = [];
        },
        // Rebuild 
        cekAlokasiDriver(ev) {
            this.forms.assign_driver = ev.nmk;
            this.forms.assign_name_driver = ev.driver_name;
        },


        updateHargaJual(list) {
            const rate = parseFloat(this.data.prorate_rate) || 0
            const trip = parseFloat(list.trip_tagih)

            if (isNaN(trip)) {
            // Jika trip_tagih kosong atau bukan angka, kembalikan ke nilai awal
            list.harga_jual = list.harga_jual_awal
            console.log(list.harga_jual);
            } else {
            list.harga_jual = trip * rate
            }
        },

        loadCalculate() {
            this.fetchData = [];
            this.isLoadingCalculate = true;
            const baseURI = this.$settings.endPoint + "lumpsum-rental/lumpsum-kalkulasi"
            this.$http
                .post(baseURI, {
                    periode: this.data.periode,
                    billable_method: this.data.billable_method,
                    sku: this.data.sku,
                    calculation_type: this.calculate.name,
                    sap_code: this.sap_code,
                    max_trip:this.data.max_trip,
                    jumlah_truck: this.data.JumlahTruck.toString(),
                    contract_rate: this.data.contract_rate,
                })
                .then((response) => {
                    this.isLoadingCalculate = false;
                    if (response) {
                      

                        this.fetchData = response.data.datas.map(item => ({
                        ...item,
                        harga_jual_awal: item.harga_jual  // simpan nilai awal
                        }))

                        // console.log(fetchData);
                    } else {

                        this.errors = response.data.errors;
                        this.resultError(response.data.errors);
                    }


                })
                .catch((error) => {
                    this.isLoadingCalculate = false;
                    if (error.response) {
                        if (error.response.status === 422) {
                            this.errors = error.response.data.errors;
                            this.resultError(this.errors); // ⬅️ panggil fungsi yang benar
                        } else {
                            this.loadError("Terjadi kesalahan yang tidak diketahui");
                        }
                    } else {
                        this.loadError("Koneksi gagal atau server tidak merespons");
                    }
                });

        },


        customLabel(ev) {
            return `${ev.nmk} – ${ev.driver_name}`
        },

        asyncSearchDriver(ev) {
            this.fetchDriver = [];
            const baseURI =
                this.$settings.endPointMPR + `v1/mpr/lookup/drivers-new?nullPic=true&jenis_driver=${this.data.jenis_driver}&search=` + ev;
            return this.$http.get(baseURI).then((response) => {
                this.fetchDriver = response.data.datas.data;
            });
        },

        formatNumber(value) {
            //console.log(value);
            return parseInt(value).toLocaleString();
        },


        submitData() {
            //this.forms.assign_date = moment(String(this.forms.assign_date)).format("YYYY-MM-DD");
            this.isLoading = true;
            let baseURI = this.$settings.endPoint + "lumpsum-rental/save-kalkulasi";
            if(this.user_type=='CT'){
                baseURI = this.$settings.endPoint + "lumpsum-rental/save-kalkulasi-ops";
            }
            console.log(baseURI);
            this.$http
                .post(baseURI, {
                    "rm_billable_rate_detail_lumpsum_report_header_id": this.data.rm_billable_rate_detail_lumpsum_report_header_id,
                    "customer_name": this.data.customer_name,
                    "customer_code": this.data.customer_code,
                    "billable_method": this.data.billable_method,
                    "periode": this.data.periode,
                    "sku": this.data.sku,
                    "max_trip": this.data.max_trip,
                    "contract_rate": this.data.contract_rate,
                    "jumlah_truck": this.data.JumlahTruck,
                    "sap_code": this.sapcode,
                    "calculation_type": this.calculate.name,
                    "kalkulasi": this.fetchData
                })
                .then((response) => {
                    this.isLoading = false;
                    if (response) {

                        this.$emit("closeModal");
                        this.loadSuccess("Success");
                    } else {

                        this.errors = response.data.errors;
                        this.resultError(response.data.errors);
                    }


                })
                .catch((error) => {
                    this.isloading = false;
                    if (error.response) {
                        if (error.response.status === 422) {
                            this.errors = error.response.data.errors;
                            this.resultError(error.response.data.errors);

                        }
                    }

                });

        },


        submitToCt(row) {
            console.log(row);
            //this.fade(true);
            const baseURI = this.$settings.endPointCt + "master-truck/update-truck-statusupdate-truck-status-for-fppk"
                .post(baseURI, row)
                .then((response) => {
                    console.log(response)
                    this.loading();
                    if (response.data.status === 200) {
                        // this.updateStatus(row.fppk_id, 'Pengajuan')

                    } else {
                        this.errors = response.data.errors;
                        this.resultError(response.data.errors);
                    }
                })
                .catch((error) => {
                    this.loading();
                    if (error.response) {
                        if (error.response.status === 422) {
                            this.errors = error.response.data.errors;
                            if (this.errors.message) {
                                this.error(this.errors.message);
                            } else {
                                this.resultError(error.response.data.errors);
                            }
                        } else if (error.response.status === 500) {
                            this.error(error.response.data.errors.message);
                        } else {
                            this.$router.push("/page-not-found");
                        }
                    }
                    //this.resetForm();
                });
        },


        resultError(data) {
            var html = "";
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    html += objectData[y] + "<br>";
                }
            }

            this.loadError(html);
        },

        loadError(pesan) {
            this.$swal({
                backdrop: true,
                title: "Warning",
                html: pesan,
                showConfirmButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
            }).then((result) => {
                if (result.value) {
                    this.isLoading = false;
                }
            })
        },

        fetchIt() {
            const userDatas = this.$getUserInfo();
            this.detailUser = userDatas.sub;
            this.company_code = userDatas.sub.company_detail.code;

            this.user_type = userDatas.sub.user_type;
            // this.permision_role = userDatas.sub.permision_role;
            let rolePermision = [];
            userDatas.sub.permision_role.forEach(function (permision) {
                if (permision.permission.controller == "RmLumpsumReportController") {
                    rolePermision = permision;
                    // console.log(permision);
                }
            });


            this.permision_role = rolePermision;
        },

        loadSuccess(pesan) {
            this.$swal({
                backdrop: true,
                title: "Success",
                html: pesan,
                showConfirmButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
            }).then((result) => {
                if (result.value) {
                    this.isLoading = false;
                }
            })
        },


    },
    created: function () {
        //this.loadDriver();

    },
    mounted() {

        const formElement = this.$refs.formElement;
        if (formElement) {
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'readonly') {
                        const inputs = formElement.querySelectorAll('.multiselect__input');
                        inputs.forEach(input => {
                            input.removeAttribute('readonly');  // Hapus readonly setiap kali diubah
                        });
                    }
                });
            });

            const inputs = formElement.querySelectorAll('.multiselect__input');
            inputs.forEach(input => {
                observer.observe(input, { attributes: true });
            });
        }


        //tail(this.data);
    },
};
</script>

<style scoped>
.modal {
    background: rgba(0, 0, 0, 0.4);
}

.modal-content {
    background: #fff;
    border-radius: 0px;
    border: none;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
    padding: 0px;
    width: 100%;
    height: 100%;
    margin-left: 0px !important;
}



.modal-dialog {
    max-width: 90vw;   /* lebar 90% layar */
    width: 90vw;
    margin: 5vh auto;  /* supaya ada jarak atas bawah */
}

</style>